/**
 * Safely extract the organization_survey_id from available context.
 * This avoids duplicating fallback logic across Interpretation and Widget components.
 *
 * @param {Object|null} selectedFactor - current factor or page context
 * @param {Object|null} widgetContext - optional widget-level context
 * @param {number|string|null} routeOrganizationSurveyId - route-level fallback
 * @returns {number|null}
 */
export const getOrganizationSurveyId = (
  selectedFactor = null,
  widgetContext = null,
  routeOrganizationSurveyId = null
) => {
  if (selectedFactor?.organization_survey_id) {
    return selectedFactor.organization_survey_id;
  }

  if (widgetContext?.organization_survey_id) {
    return widgetContext.organization_survey_id;
  }

  // Future-proof: allow reading from sessionStorage if user context holds it
  const stored = sessionStorage.getItem("organization_survey_id");
  if (stored) return Number(stored);

  if (routeOrganizationSurveyId) {
    return Number(routeOrganizationSurveyId);
  }

  console.warn("[getOrganizationSurveyId] No organization_survey_id found.");
  return null;
};

const firstPresentValue = (...values) =>
  values.find((value) => value != null && String(value).trim() !== "");

export const getOrganizationSurveyName = (survey = {}) =>
  firstPresentValue(
    survey?.name,
    survey?.surveyName,
    survey?.survey_name,
    survey?.survey?.name
  ) || "";

export const getSurveyPeriodLabel = (survey = {}) => {
  const surveyPeriod = survey?.survey_period || {};

  return firstPresentValue(
    surveyPeriod?.name,
    surveyPeriod?.key,
    survey?.survey_period_name,
    survey?.survey_period_key,
    survey?.periodName,
    survey?.periodKey,
    survey?.period
  ) || "";
};

export const formatOrganizationSurveyTitle = (
  survey = {},
  { translateSurveyName } = {}
) => {
  const rawName = getOrganizationSurveyName(survey);
  const surveyName = translateSurveyName ? translateSurveyName(rawName) : rawName;
  const periodLabel = getSurveyPeriodLabel(survey);

  if (!surveyName) return periodLabel;
  if (!periodLabel) return surveyName;

  return `${surveyName} (${periodLabel})`;
};
